const messages = {
    en: {
        dataSourceType: {
            odometer: "virtual sensor",
            sensors: "CANBUS",
            counters: "counters"
        },
        userSettings: {
            title: "User Settings",
            subtitle: "Here you can update your account settings",
            wialonToken: "Wialon Access Token",
            wialonTokenDescription: "Update your Wialon access token by clicking this button",
            updateButtonText: "Update Access Token",
            tokenUpdated: "Token updated successfully",
            tokenUpdateError: "Error updating token. Please retry later"
        },
        signUp: {
            title: "Welcome {name} {surname}",
            subtitle: "You are about to activate your HubLogiQ Trips account, linked to {email}",
            wialonButtonDescription: "Click the button below to log in to Wialon and sync your data",
            wialonButtonText: "Login to Wialon",
            invitationError: "The invitation could not be found, please retry later",
            firstNameError: "A first name is required",
            surnameError: "A surname is required",
            passwordError: "A password is required",
            wialonError: "You need to log in to Wialon before continuing",
            registrationComplete: "Registration Complete",
            registrationError: "The registration could not be completed. Please retry later"
        },
        passwordReset: {
            title: "Password Reset",
            subtitle: "You are about to reset the password for {email}",
            success: "Password changed",
            genericError: "The password reset could not be completed. Please retry later",
            invalidLink: "Invalid password reset link"
        },
        notifications: {
            title: "Notifications",
            trackedUnits: "Tracked units",
            trackedUnitsSubtitle: "The following units will trigger an email notification when the chosen private use threshold (in kilometers) is exceeded in the current year",
            untrackedUnits: "Untracked units",
            loadingError: "Could not load notifications. Please try logging in again",
            triggerNumberError: "The notification trigger must be a number",
            triggerBoundsError: "The notification trigger must be higer than 0 and lower than 500",
            saved: "Notification saved",
            removed: "Notification removed",
            enabled: "Notification enabled",
            disabled: "Notification disabled",
            startedRefresh: "Started notification refresh for {unitName}",
            updated: "Notification {unitName} updated",
            tokenRefreshNeeded: "A token refresh is needed for notification {unitName}",
            triggerPlaceholder: "Notification mileage limit",
            lastExecutionDate: "The most recent notification was sent at: {notificationDate}."
        },
        login: {
            title: "Login",
            forgottenPassword: "Have you forgotten your password?",
            backToLogin: "Back to login",
            passwordResetButtonText: "Send Password Reset",
            passwordResetEmailSent: "Password reset sent if the email exists",
            invalidCredentials: "Invalid credentials, please retry",
            success: "Login successful"
        },
        jobPreview: {
            title: "Preview job {jobName}",
            unitName: "Vehicle {name}",
            loadingError: "Could not load trips. Please retry later",
            pdfError: "Could not generate the PDF. Please retry later",
            missingUnitSensor: "One or more units have no mileage sensor",
            missingReport: "The current token does not have a unit trips report"
        },
        editJob: {
            title: "Edit job {jobName}",
            jobNamePlaceholder: "Job name (e.g. ACME B.V. vans)",
            jobEmailPlaceholder: "Which email the report should be sent to?",
            saved: "Job saved"
        },
        dashboard: {
            otfReportTitle: "Generate on-the-fly Report",
            scheduledReportTitle: "Create New Scheduled Report",
            jobEnabled: "Job enabled",
            jobDisabled: "Job disabled",
            jobDeleted: "Job deleted",
            jobStarted: "Started job {name}",
            jobExecuted: "Job {name} executed",
            unitLoadingError: "Could not load units, please retry",
            jobsLoadingError: "Could not load jobs. Please try logging in again",
            jobDescription: "Executes {executionInterval}. Emails are sent to {mailto}."
        },
        admin: {
            title: "Invite new user",
            inviteButtonText: "Invite User",
            users: "Users",
            userLoadingError: "Could not load users. Please try again later",
            confirmDeletion: "Do you want to delete user {name} ({username})",
            userDeleted: "User deleted",
            userDeletedError: "Could not delete user. Please try again later",
            invitationSent: "Invitation sent",
            invitationError: "Could not invite user. Please try again later"
        },
        jobs: {
            title: "Scheduled reports",
            jobNamePlaceholder: "Job name (e.g. ACME B.V. company vans)",
            emailPlaceholder: "Which email the report should be sent to?",
            saved: "Job saved",
            reportName: "Report name"
        },
        misc: {
            languageUpdated: "Language changed",
            languageUpdateFailed: "Could not change language. Please retry later",
            driver: "Driver",
            notes: "Notes",
            business: "Business",
            private: "Personal",
            deleted: "Deleted",
            saved: "Saved",
            execute: "Execute",
            preview: "Preview",
            add: "Add",
            edit: "Edit",
            save: "Save",
            delete: "Delete",
            cancel: "Cancel",
            disable: "Disable",
            enable: "Enable",
            refreshData: "Refresh data",
            never: "Never",
            name: "Name",
            email: "Email",
            surname: "Surname",
            password: "Password",
            confirmPassword: "Confirm password",
            namePlaceholder: "First Name",
            surnamePlaceholder: "Surname",
            passwordPlaceholder: "Your password",
            continue: "Continue",
            confirm: "Confirm",
            invalidReCAPTCHA: "Invalid ReCAPTCHA",
            formIncomplete: "The form is incomplete",
            formErrors: "There are errors with the form. Please retry",
            nonMatchingPasswords: "The passwords do not match",
            actionsHeader: "Actions",
            mailtoHeader: "Mail to",
            privateUseHeader: "Private use (km)",
            triggerHeader: "Trigger (km)",
            lastUpdateHeader: "Last update",
            unitNameHeader: "Unit name",
            jobNameHeader: "Job name",
            frequencyHeader: "Frequency",
            role: "Role",
            roleHeader: "Role",
            userHeader: "User",
            genericError: "Something went wrong, please retry",
            clickHere: "Click here",
            login: "Login",
            startTime: "Start time",
            endTime: "End time",
            duration: "Duration",
            fromLocation: "From",
            toLocation: "To",
            initialMileage: "Start (km)",
            finalMileage: "End (km)",
            mileage: "Mileage (km)",
            status: "Status",
            tripType: "Type",
            download: "Download",
            logoutMessage: "Logout successful",
            generateReport: "Generate Report",
            missingDateInterval: "Select a date interval",
            daily: "Daily",
            weekly: "Weekly",
            monthly: "Monthly",
            custom: "Custom",
            numberOfDays: "Number of days",
            selectUnits: "Select vehicles",
            addUnit: "Add an unit",
            selectSource: "Select source",
            dataSource: "Data source",
            clickToSelect: "Click to select...",
            dateRangeHeader: "Date Range",
            dateFromHeader: "From date",
            dateToHeader: "To date",
            refresh: "Refresh",
            triggerInKm: "Trigger in km",
            job: "Job"
        },
        navbar: {
            reportsHeader: "Reports",
            notificationsHeader: "Notifications",
            settingsHeader: "Settings",
            adminHeader: "Admin Panel",
            documentationHeader: "Documentation",
            logout: "Logout"
        }
    },
    nl: {
        dataSourceType: {
            odometer: "virtuele sensor",
            sensors: "CANBUS",
            counters: "kilometerteller"
        },
        userSettings: {
            title: "Gebruikersinstellingen",
            subtitle: "Hier kunt u uw gebruikersinstellingen bijwerken",
            wialonToken: "Wialon Access Token",
            wialonTokenDescription: "Druk op deze knop om jouw Wialon access token bijwerken",
            updateButtonText: "Access Token bijwerken",
            tokenUpdated: "Token bijgewerkt",
            tokenUpdateError: "Fout bij het bijwerken van het token. Probeer het later opnieuw"
        },
        signUp: {
            title: "Welkom {name} {surname}",
            subtitle: "Hier kunt u het HubLogiQ Trips account van {email} activeren",
            wialonButtonDescription: "Druk op de knop onder voor de Wialon inloggen en data synchroniseren",
            wialonButtonText: "Wialon Inloggen",
            invitationError: "Kan het uitnodiging niet vinden. Probeer het later opnieuw",
            firstNameError: "Voornaam is verplicht",
            surnameError: "Achternaam is verplicht",
            passwordError: "Wachtwoord is verplicht",
            wialonError: "Je moet inloggen op Wialon voordat je verder gaan",
            registrationComplete: "Aanmelden compleet",
            registrationError: "De aanmelden kan niet worden voltooid. Probeer het later opnieuw"
        },
        passwordReset: {
            title: "Wachtwoord opnieuw instellen",
            subtitle: "Je bent het wachtwoord voor {email} aan het bijwerken",
            success: "Wachtwoord bijgewerkt",
            genericError: "Opnieuw instellen van het wachtwoord is mislukt. Probeer het later opnieuw",
            invalidLink: "Ongeldige wachtwoord opnieuw instellen koppeling"
        },
        notifications: {
            title: "Meldingen",
            trackedUnits: "Getraceerde eenheden",
            trackedUnitsSubtitle: "De volgende eenheden sturen een mail wanneer de drempel voor de privé gereden kilometers boven de trigger (in kilometers) voor het huidige jaar komt.",
            untrackedUnits: "Niet getraceerde eenheden",
            loadingError: "Meldingen kan niet worden geladen. Probeer het later opnieuw",
            triggerNumberError: "Het trigger van de melding moet een nummer zijn",
            triggerBoundsError: "Het trigger van de melding moet groter dan 0 zijn en kleiner (of gelijk aan) dan 500.",
            saved: "Melding opgeslagen",
            removed: "Melding verwijderen",
            enabled: "Melding inschakelen",
            disabled: "Melding uitschakelen",
            startedRefresh: "Vernieuwen gestart voor melding {unitName}",
            updated: "Melding {unitName} bijwerkt",
            tokenRefreshNeeded: "Token vernieuwen verplicht voor melding {unitName}",
            triggerPlaceholder: "melding kilometerstand trigger",
            lastExecutionDate: "De meest recente melding werd verzonden op: {notificationDate}."
        },
        login: {
            title: "Inloggen",
            forgottenPassword: "Wachtwoord vergeten",
            backToLogin: "Terug naar inloggen",
            passwordResetButtonText: "E-mail voor het opnieuw instellen van een wachtwoord verzenden",
            passwordResetEmailSent: "E-mail voor het opnieuw instellen van een wachtwoord verzonden als het gebruiker bestaat",
            invalidCredentials: "Ongeldige referenties, probeer het opnieuw",
            success: "Aangemeld"
        },
        jobPreview: {
            title: "Voorbeeld rapport {jobName}",
            unitName: "Kenteken {name}",
            loadingError: "Reizen kan niet worden geladen. Probeer het later opnieuw",
            pdfError: "PDF kan niet worden gegenereerd. Probeer het later opnieuw",
            missingUnitSensor: "Een of meer eenheid heeft geen kilometerstand sensor",
            missingReport: "De huidige token heeft geen rittenrapport van de eenheid"
        },
        editJob: {
            title: "Taak {jobName} bewerken",
            jobNamePlaceholder: "Rapport naam (bijv. ACME b.v.)",
            jobEmailPlaceholder: "Stuur het rapport naar",
            saved: "Taak gered"
        },
        dashboard: {
            otfReportTitle: "Rapport Genereren",
            scheduledReportTitle: "Maak Een Nieuw Gepland Rapport",
            jobEnabled: "Taak ingeschakeld",
            jobDisabled: "Taak uitgeschakeld",
            jobDeleted: "Taak verwijderd",
            jobStarted: "Taak {name} gestart",
            jobExecuted: "Taak {name} uitgevoerd",
            unitLoadingError: "Eenheden kan niet worden geladen. Probeer het opnieuw",
            jobsLoadingError: "Taken kan niet worden geladen. Probeer het opnieuw",
            jobDescription: "Wordt {executionInterval} uitgevoerd. E-mails worden verzonden naar {mailto}."
        },
        admin: {
            title: "Nieuwe gebruiker uitnodigen",
            inviteButtonText: "Gebruiker Uitnodigen",
            users: "Gebruikers",
            userLoadingError: "Gebruikers kan niet worden geladen. Probeer het opnieuw",
            confirmDeletion: "Wilt u de gebruiker {name} ({username}) verwijderen?",
            userDeleted: "Gebruiker is verwijderd",
            userDeletedError: "Het gebruiker kan niet worden verwijderd. Probeer het opnieuw",
            invitationSent: "Uitnodiging verzonden",
            invitationError: "Kan de nieuwe gebruiker niet uitnodigen. Probeer het opnieuw"
        },
        jobs: {
            title: "Geplande rapporten",
            jobNamePlaceholder: "Rapport naam (bijv. ACME b.v.)",
            emailPlaceholder: "Stuur het rapport naar",
            saved: "Taak opgeslagen",
            reportName: "Rapport naam"
        },
        misc: {
            languageUpdated: "Taal gewijzigd",
            languageUpdateFailed: "Taal kan niet worden wijzigen. Probeer het later opnieuw",
            driver: "Bestuurder",
            notes: "Notities",
            business: "Zakelijk",
            private: "Prive",
            deleted: "Verwijderd",
            saved: "Opgeslagen",
            execute: "Uitgevoerd",
            preview: "Voorbeeld",
            add: "Toevoegen",
            edit: "Bewerken",
            save: "Opslaan",
            delete: "Verwijderen",
            cancel: "Annuleren",
            disable: "Uitschakelen",
            enable: "Inschakelen",
            refreshData: "Gegevens vernieuwen",
            never: "Nooit",
            name: "Naam",
            email: "Email",
            surname: "Achternaam",
            password: "Wachtwoord",
            confirmPassword: "Wachtwoord bevestigen",
            namePlaceholder: "Voornaam",
            surnamePlaceholder: "Achternaam",
            passwordPlaceholder: "Jouw wachtwoord",
            continue: "Doorgaan",
            confirm: "Bevestigen",
            invalidReCAPTCHA: "Ongeldig ReCAPTCHA",
            formIncomplete: "De formulier is onvolledig",
            formErrors: "Het formulier bevat fouten. Probeer opnieuw",
            nonMatchingPasswords: "Wachtwoorden komen niet overeen",
            actionsHeader: "Acties",
            mailtoHeader: "E-mail verzenden aan",
            privateUseHeader: "Privé (km)",
            triggerHeader: "Trigger (km)",
            lastUpdateHeader: "Laatste update",
            unitNameHeader: "Eenheid naam",
            jobNameHeader: "Rapport naam",
            frequencyHeader: "Frequentie",
            role: "Rol",
            roleHeader: "Rol",
            userHeader: "Gebruiker",
            genericError: "Er is iets fout gegaan, probeer het opnieuw",
            clickHere: "Klik hier",
            login: "Inloggen",
            startTime: "Starttijd",
            endTime: "Eindtijd",
            duration: "Duur",
            fromLocation: "Van",
            toLocation: "Tot",
            initialMileage: "Begin (km)",
            finalMileage: "Eind (km)",
            mileage: "Afstand (km)",
            status: "Status",
            tripType: "Type",
            download: "Downloaden",
            logoutMessage: "Afgemeld",
            generateReport: "Rapport Genereren",
            missingDateInterval: "Datumbereik selecteren",
            daily: "Dagelijks",
            weekly: "Wekelijks",
            monthly: "Maandelijks",
            custom: "Aangepast",
            numberOfDays: "Aantal dagen",
            selectUnits: "Kenteken selecteren",
            addUnit: "Kenteken toevoegen",
            selectSource: "Bron selecteren",
            dataSource: "Gegevensbron",
            clickToSelect: "Klik om te selecteren...",
            dateRangeHeader: "Datumbereik",
            dateFromHeader: "Vanaf",
            dateToHeader: "Tot",
            refresh: "Vernieuwen",
            triggerInKm: "Trigger (km)",
            job: "Rapport"
        },
        navbar: {
            reportsHeader: "Rapporten",
            notificationsHeader: "Meldingen",
            settingsHeader: "Instellingen",
            adminHeader: "Admin Dashboard",
            documentationHeader: "Documentatie",
            logout: "Uitloggen"
        }
    }
}

export default messages;